'use client';

import React from 'react';
import chunk from 'lodash/chunk';
import { Pagination, Virtual, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Box from '@mui/material/Box';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const BaseSwiper = (props: {
  chunkData: any[];
  swiperEle: (data: any) => React.ReactNode;
  className?: string;
  chunkSize?: number;
  spaceBetween?: number;
  showNavigation?: boolean;
  showPagination?: boolean;
}) => {
  const {
    className = '',
    chunkData,
    chunkSize = 12,
    swiperEle,
    spaceBetween = 16,
    showNavigation,
    showPagination = true,
  } = props;
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  return (
    <Box
      className={className}
      sx={{
        '.swiper-pagination-bullet': {
          height: '4px',
          width: '24px',
          borderRadius: '4px',
          backgroundColor: '#e4e2e0',
          margin: '0 4px 0 0 !important',
          transition: 'background-color .5s ease,width .3s linear',
          '&s': { bottom: '0px !important' },
          '&:not(&-active):hover': {
            opacity: 1,
            backgroundColor: '#949494 !important',
          },
          '&-active': {
            backgroundColor: '#949494',
          },
        },
      }}
    >
      {showNavigation && (
        <>
          <button
            ref={prevRef}
            className="swiper-prev text-white absolute right-10 top-2 flex items-center justify-center rounded-full bg-web-neutral-500 transition-colors duration-250 disabled:bg-web-grey-650 hover:bg-web-grey-600"
          >
            <ChevronLeftIcon />
          </button>
          <button
            ref={nextRef}
            className="swiper-next text-white absolute right-0 top-2 flex items-center justify-center rounded-full bg-web-neutral-500 transition-colors duration-250 disabled:bg-web-grey-650 hover:bg-web-grey-600"
          >
            <ChevronRightIcon />
          </button>
        </>
      )}
      <Swiper
        modules={[Pagination, Virtual, Navigation]}
        preventClicks={true}
        preventClicksPropagation={true}
        pagination={
          showPagination && {
            clickable: true,
          }
        }
        spaceBetween={spaceBetween}
        onBeforeInit={(swiper: {
          params: { navigation: { prevEl: null; nextEl: null } };
        }) => {
          if (showNavigation) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
        navigation={
          showNavigation && {
            prevEl: '.swiper-prev',
            nextEl: '.swiper-next',
          }
        }
        className="-m-3"
      >
        {chunk(chunkData, chunkSize).map((item, i) => (
          <SwiperSlide
            key={i}
            tag="ul"
            className={`list-none !ml-0 p-3 ${showPagination ? 'pb-8' : 'pb-3'} grid grid-cols-4 gap-x-4 gap-y-5`}
          >
            {item.map((cItem) => swiperEle(cItem))}
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default BaseSwiper;
